import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuizMeQuestions = ({
  questionIndex,
  quizTitle,
  quizQuestions
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState();
  const progressValue = questionIndex + (selectedAnswer !== undefined ? 1 : 0);
  const progressPercentage = progressValue / quizQuestions.length * 100;
  const handleSelectAnswer = answerIndex => () => setSelectedAnswer(answerIndex);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.quizTitle",
        options: {
          quizTitle
        }
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlock: "800",
      children: /*#__PURE__*/_jsx("b", {
        children: quizQuestions[questionIndex].questionTitle
      })
    }), /*#__PURE__*/_jsxs(View, {
      marginBlock: "800",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.progress",
        options: {
          progress: progressValue,
          total: quizQuestions.length
        }
      }), /*#__PURE__*/_jsx(Progress, {
        value: progressPercentage
      })]
    }), quizQuestions[questionIndex].answers.map((answer, index) => /*#__PURE__*/_jsx(SelectableButton, {
      onClick: handleSelectAnswer(index),
      selected: selectedAnswer === index,
      children: answer.answerText
    }, answer.answerText)), selectedAnswer !== undefined && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlock: "800",
        children: /*#__PURE__*/_jsx("b", {
          children: quizQuestions[questionIndex].answers[selectedAnswer].answerResponseTitle
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: quizQuestions[questionIndex].answers[selectedAnswer].answerResponseText
      })]
    })]
  });
};
export default QuizMeQuestions;